import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { DateTime } from 'luxon';
import { MonthEnum } from '@api/models/months-enum';
import { MonthTranslations } from '@app/core/translations';

@Component({
  selector: 'flow-calendar-nav',
  templateUrl: './calendar-nav.component.html',
  styleUrls: ['./calendar-nav.component.scss'],
})
export class CalendarNavComponent implements OnChanges {
  @Input() date: string;
  @Output() dateChange: EventEmitter<string> = new EventEmitter<string>();

  monthTranslationKey: string;
  year: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date']) {
      const monthNumber = DateTime.fromISO(this.date).month as MonthEnum;
      this.monthTranslationKey = MonthTranslations[monthNumber];
      this.year = DateTime.fromISO(this.date).year;
    }
  }

  prevMonth() {
    const selectedDate = DateTime.fromISO(this.date).minus({ months: 1 });
    const isoDate = selectedDate.toISODate();
    this.dateChange.emit(isoDate);
  }

  nextMonth() {
    const selectedDate = DateTime.fromISO(this.date).plus({ months: 1 });
    const isoDate = selectedDate.toISODate();
    this.dateChange.emit(isoDate);
  }

  currentMonth() {
    const currentDate = DateTime.local().toISODate();
    this.dateChange.emit(currentDate);
  }
}
